import qs from "qs";

(() => {
  const params = qs.parse(location.search.substring(1));
  if (typeof params.pap === "string") {
    localStorage.setItem("gift.postal.pap", params.pap);
  }
})();
